import React from "react"
import { Chip } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"
import { DOULA_SERVICES_SELECT_OPTIONS } from "#/pages/provider-finder/components/sidebar/DoulaServicesFilter"

interface DoulaServicesChipsProps {
  doulaServices?: string[]
}

export function DoulaServicesChips({ doulaServices }: DoulaServicesChipsProps): JSX.Element | null {
  const intl = useIntl()
  if (!doulaServices || !doulaServices.length) {
    return null
  }

  return (
    <>
      {doulaServices.map((service) => {
        const serviceKey = service.toLowerCase()
        const labelMessage = DOULA_SERVICES_SELECT_OPTIONS.find((option) => option.value === serviceKey)?.label

        return <Chip key={service} size="small" label={intl.formatMessage(labelMessage)} />
      })}
    </>
  )
}
